import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService} from "../../../../@shared/services/user.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {IFreeCasesLog} from "../services/interfaces/free-cases.interface";
import {environment} from "../../../../../environments/environment";
import {FormControl} from "@angular/forms";
import {Subject} from "rxjs";
import {filter, takeUntil} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {AddFreeUserCasesComponent} from "./modals/add-free-user-cases/add-free-user-cases.component";

@Component({
  selector: 'app-free-cases',
  templateUrl: './free-cases.component.html',
  styleUrls: ['./free-cases.component.scss']
})
export class FreeCasesComponent implements OnDestroy, OnInit {
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  public userFreeCaseColumns = ['count', 'case-name', 'created', 'used', 'agentKey', 'data'];
  public userFreeCaseData: MatTableDataSource<IFreeCasesLog> = new MatTableDataSource();

  public userFreeCases: IFreeCasesLog[] = [];
  public filterButton: FormControl = new FormControl<string>('all');
  public isLoading = true;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(private userService: UserService,
              private dialog: MatDialog) {
    this.subscribeEmitters();
  }

  ngOnInit() {
    this.userService.requestFreeCasesLog();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public openAddFreeUserCasesDialog(): void {
    this.dialog.open(AddFreeUserCasesComponent)
      .afterClosed()
      .pipe(
        filter(value => !!value)
      )
      .subscribe(() => this.userService.requestFreeCasesLog());
  }

  private subscribeEmitters(): void {
    this.userService.freeCasesLog$
      .subscribe((freeCases: IFreeCasesLog[]) => {
        this.userFreeCases = freeCases;
        this.userFreeCaseData.data = freeCases;
        this.userFreeCaseData.paginator = this.paginator;
        this.isLoading = false;
      })

    this.filterButton.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((value: string) => {
        switch (value) {
          case 'all':
            this.userFreeCaseData.data = this.userFreeCases;
            break;
          case 'used':
            this.userFreeCaseData.data = [...this.userFreeCases].filter((item: IFreeCasesLog) => item.usedAt)
            break;
          case 'notUsed':
            this.userFreeCaseData.data = [...this.userFreeCases].filter((item: IFreeCasesLog) => !item.usedAt)
            break;
        }
      })
  }
}
